import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import logo from '../assets/logo.jpg';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white/90 p-4 shadow-sm backdrop-blur-md border-b border-gray-100">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <div className="text-2xl font-bold flex items-center">
          <img 
            src={logo} 
            alt="PeerchargeEV Logo" 
            className="h-[35px] w-[35px] mr-2 rounded-full"
          />
          <Link to="/" className="cursor-pointer text-gray-900">
            Peercharge<span className="text-brand-green">EV</span>
          </Link>
        </div>
        
        {/* Mobile Hamburger */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-gray-700 hover:text-brand-green focus:outline-none"
            aria-label="Toggle menu"
          >
             {menuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-8 items-center">
          <li>
            <Link to="/" className="text-gray-600 hover:text-brand-green text-sm font-medium transition-colors">
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" className="text-gray-600 hover:text-brand-green text-sm font-medium transition-colors">
              About
            </Link>
          </li>
          <li>
            <Link to="/blog" className="text-gray-600 hover:text-brand-green text-sm font-medium transition-colors">
              Blog
            </Link>
          </li>
          <li>
            <Link to="/calculators" className="text-gray-600 hover:text-brand-green text-sm font-medium transition-colors">
              Calculators
            </Link>
          </li>
           <li>
            <Link to="/faq" className="text-gray-600 hover:text-brand-green text-sm font-medium transition-colors">
              FAQ
            </Link>
          </li>
          <li>
            <Link to="/deleteData" className="text-gray-600 hover:text-brand-green text-sm font-medium transition-colors">
              Manage Data
            </Link>
          </li>
        </ul>

        {/* Action Button */}
        <div className="hidden md:block">
           <a 
              href="https://play.google.com/store/apps/details?id=com.niloy.peerchargerev"
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-brand-green hover:bg-green-600 text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-all flex items-center gap-2 shadow-lg shadow-brand-green/30"
           >
              Download App <ArrowRight size={16} />
           </a>
        </div>
      </div>

      {/* Mobile menu dropdown */}
      {menuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg px-4 py-4 flex flex-col space-y-4">
            <Link to="/" onClick={() => setMenuOpen(false)} className="text-gray-700 hover:text-brand-green font-medium">Home</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)} className="text-gray-700 hover:text-brand-green font-medium">About</Link>
            <Link to="/blog" onClick={() => setMenuOpen(false)} className="text-gray-700 hover:text-brand-green font-medium">Blog</Link>
            <Link to="/calculators" onClick={() => setMenuOpen(false)} className="text-gray-700 hover:text-brand-green font-medium">Calculators</Link>
            <Link to="/faq" onClick={() => setMenuOpen(false)} className="text-gray-700 hover:text-brand-green font-medium">FAQ</Link>
            <Link to="/deleteData" onClick={() => setMenuOpen(false)} className="text-gray-700 hover:text-brand-green font-medium">Manage Data</Link>
            <a 
              href="https://play.google.com/store/apps/details?id=com.niloy.peerchargerev"
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-brand-green hover:bg-green-600 text-white px-5 py-3 rounded-full text-center font-semibold flex items-center justify-center gap-2 mt-4"
           >
              Download App <ArrowRight size={18} />
           </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;